import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink, RouterOutlet } from '@angular/router';
import { TestRequest } from '../../models/TestRequest';
import { TestRequestService } from '../../services/test-request.service';


//import 'rxjs/add/operator/toPromise';
import saveAs from 'file-saver';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-request-details',
  standalone: true,
  imports: [DatePipe, RouterLink, RouterOutlet ],
  templateUrl: './request-details.component.html',
  styleUrl: './request-details.component.css'
})
export class RequestDetailsComponent implements OnInit {

  Id: string = "";
  constructor(private activatedRoute: ActivatedRoute,
    private testRequestService: TestRequestService, private http: HttpClient) {
  }
  testRequest: TestRequest = new TestRequest();
  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.Id = params['id'];
      this.testRequestService.getTestRequest(this.Id).subscribe(data => { this.testRequest = data });
    })
  }

  downloadRequestPdf() {

    let headers = new HttpHeaders();
    headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token') ||"").access_token);
    headers.append("Accept", "application/octet-stream");
    this.http.get('api/testrequest/' + this.Id + '/pdf', { responseType: 'blob', headers: headers }).toPromise()
      .then((response : any) => this.saveToFileSystem(response));
  }

  private saveToFileSystem(response : any) {
    const contentDispositionHeader: string = response.headers.get('Content-Disposition');
    const parts: string[] = contentDispositionHeader.split(';');
    const filename = parts[1].split('=')[1].replace(' ', '');
    const blob = new Blob([response._body], { type: 'text/plain' });
    saveAs(blob, filename);
  }
}
